import ajax from '../../lib/ajax';
import warehouseInfo from '../entities/warehouseInfo'
const warehouseInfoModule = {
    namespaced: true,
    state: {

    },
    actions: {
        async get(state: any, payload: any) {
            let rep = await ajax.get('/api/services/app/WarehouseInfo/GetWarehouseInfoList',  { params: payload.data });
            return rep.data.result as Array<warehouseInfo>;
        },
    }
}
export default warehouseInfoModule;